/* DERMEXA community & reviews — minimal, native, no libraries */
(function(){
  'use strict';
  // review filter + sort (native fallback list)
  document.querySelectorAll('.dx-reviews').forEach(function(root){
    var filters=root.querySelectorAll('.dx-filter');
    var sort=root.querySelector('.dx-sort');
    var list=root.querySelector('.dx-review-list');
    if(!list)return;
    function cards(){return Array.prototype.slice.call(list.querySelectorAll('.dx-review-card'));}
    function starsOf(c){return c.querySelectorAll('.dx-stars span.on').length;}
    filters.forEach(function(btn){
      btn.addEventListener('click',function(){
        filters.forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        var f=btn.getAttribute('data-filter');
        cards().forEach(function(c){
          var show=true;
          if(f==='photos')show=!!c.querySelector('.dx-review-photo');
          else if(f==='verified')show=!!c.querySelector('.dx-verified');
          else if(f!=='all')show=starsOf(c)===parseInt(f,10);
          c.style.display=show?'':'none';
        });
      });
    });
    if(sort){
      sort.addEventListener('change',function(){
        var v=sort.value,arr=cards();
        arr.sort(function(a,b){
          if(v==='highest')return starsOf(b)-starsOf(a);
          if(v==='lowest')return starsOf(a)-starsOf(b);
          if(v==='helpful'){
            var ha=parseInt((a.querySelector('.dx-helpful')||{}).textContent||'0',10)||0;
            var hb=parseInt((b.querySelector('.dx-helpful')||{}).textContent||'0',10)||0;
            return hb-ha;
          }
          return 0; // newest = source order
        });
        arr.forEach(function(c){list.appendChild(c);});
      });
    }
  });

  // smooth scroll from summary count link to #dx-reviews
  document.querySelectorAll('a[href="#dx-reviews"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var t=document.getElementById('dx-reviews');
      if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}
    });
  });

  // simple lightbox for gallery
  document.querySelectorAll('.dx-gallery-item').forEach(function(a){
    a.addEventListener('click',function(e){
      e.preventDefault();
      var ov=document.createElement('div');
      ov.className='dx-lightbox';
      ov.style.cssText='position:fixed;inset:0;z-index:9999;background:rgba(20,36,31,.85);display:grid;place-items:center;padding:30px;cursor:zoom-out';
      var img=document.createElement('img');
      img.src=a.getAttribute('href');
      img.style.cssText='max-width:92vw;max-height:88vh;border-radius:12px';
      ov.appendChild(img);
      ov.addEventListener('click',function(){ov.remove();});
      document.body.appendChild(ov);
    });
  });
})();
